(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1698],{

/***/ "./node_modules/@chakra-ui/image/dist/index.esm.js":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": function() { return /* binding */ Image2; },
/* harmony export */   "d9": function() { return /* binding */ useImage; }
/* harmony export */ });
/* unused harmony exports Img, shouldShowFallbackImage */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react_use_safe_layout_effect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/@chakra-ui/react-use-safe-layout-effect/dist/index.esm.js");
// ../../../react-shim.js


// src/image.tsx


// ../../utilities/object-utils/src/index.ts
function omit(object, keysToOmit = []) {
  const clone = Object.assign({}, object);
  for (const key of keysToOmit) {
    if (key in clone)
      delete clone[key];
  }
  return clone;
}

// src/use-image.ts


function useImage(props) {
  const {
    loading,
    src,
    srcSet,
    onLoad,
    onError,
    crossOrigin,
    sizes,
    ignoreFallback
  } = props;
  const [status, setStatus] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("pending");
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setStatus(src ? "loading" : "pending");
  }, [src]);
  const imageRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  const load = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    if (!src)
      return;
    flush();
    const img = new Image();
    img.src = src;
    if (crossOrigin)
      img.crossOrigin = crossOrigin;
    if (srcSet)
      img.srcset = srcSet;
    if (sizes)
      img.sizes = sizes;
    if (loading)
      img.loading = loading;
    img.onload = (event) => {
      flush();
      setStatus("loaded");
      onLoad == null ? void 0 : onLoad(event);
    };
    img.onerror = (error) => {
      flush();
      setStatus("failed");
      onError == null ? void 0 : onError(error);
    };
    imageRef.current = img;
  }, [src, crossOrigin, srcSet, sizes, onLoad, onError, loading]);
  const flush = () => {
    if (imageRef.current) {
      imageRef.current.onload = null;
      imageRef.current.onerror = null;
      imageRef.current = null;
    }
  };
  (0,_chakra_ui_react_use_safe_layout_effect__WEBPACK_IMPORTED_MODULE_1__/* .useSafeLayoutEffect */ .G)(() => {
    if (ignoreFallback)
      return void 0;
    if (status === "loading") {
      load();
    }
    return () => {
      flush();
    };
  }, [status, load, ignoreFallback]);
  return ignoreFallback ? "loaded" : status;
}
var shouldShowFallbackImage = (status, fallbackStrategy) => status !== "loaded" && fallbackStrategy === "beforeLoadOrError" || status === "failed" && fallbackStrategy === "onError";

// src/native-image.tsx

var NativeImage = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function NativeImage2(props, ref) {
  const { htmlWidth, htmlHeight, alt, ...rest } = props;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    width: htmlWidth,
    height: htmlHeight,
    ref,
    alt,
    ...rest
  });
});
NativeImage.displayName = "NativeImage";

// src/image.tsx
var Image2 = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function Image3(props, ref) {
  const {
    fallbackSrc,
    fallback,
    src,
    srcSet,
    align,
    fit,
    loading,
    ignoreFallback,
    crossOrigin,
    fallbackStrategy = "beforeLoadOrError",
    referrerPolicy,
    ...rest
  } = props;
  const providedFallback = fallbackSrc !== void 0 || fallback !== void 0;
  const shouldIgnoreFallbackImage = loading != null || ignoreFallback || !providedFallback;
  const status = useImage({
    ...props,
    ignoreFallback: shouldIgnoreFallbackImage
  });
  const showFallbackImage = shouldShowFallbackImage(status, fallbackStrategy);
  const shared = {
    ref,
    objectFit: fit,
    objectPosition: align,
    ...shouldIgnoreFallbackImage ? rest : omit(rest, ["onError", "onLoad"])
  };
  if (showFallbackImage) {
    if (fallback)
      return fallback;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.img */ .m$.img, {
      as: NativeImage,
      className: "chakra-image__placeholder",
      src: fallbackSrc,
      ...shared
    });
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.img */ .m$.img, {
    as: NativeImage,
    src,
    srcSet,
    crossOrigin,
    loading,
    referrerPolicy,
    className: "chakra-image",
    ...shared
  });
});
Image2.displayName = "Image";

// src/img.tsx

var Img = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)((props, ref) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.img */ .m$.img, {
  ref,
  as: NativeImage,
  className: "chakra-image",
  ...props
}));



/***/ }),

/***/ "./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Fcareers%2Findex.tsx&page=%2Fcareers!":
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/careers",
      function () {
        return __webpack_require__("./src/pages/careers/index.tsx");
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ "./src/components/Careers/CareersCard.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/@chakra-ui/button/dist/index.esm.js");



const CareerCard = (param)=>{
    let { title , description , location , link  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        boxShadow: "md",
        borderRadius: "16px",
        border: "1px solid",
        borderColor: "careersCardBorder",
        p: "6",
        bgColor: "careersCardBg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6, {
                color: "brandLinkColor",
                fontWeight: 700,
                fontSize: {
                    base: "24px",
                    lg: "36px"
                },
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                mt: {
                    base: "2",
                    md: "3"
                },
                color: "careersTextColor",
                fontWeight: 600,
                fontSize: {
                    base: "16px",
                    lg: "18px"
                },
                children: location
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                mt: {
                    base: "3",
                    md: "4"
                },
                color: "careersTextColor",
                fontWeight: 500,
                fontSize: {
                    base: "16px",
                    lg: "18px"
                },
                whiteSpace: "pre-line",
                children: description
            }),
            link && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                mt: {
                    base: "4",
                    md: "6"
                },
                justifyContent: "flex-end",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                    as: "a",
                    href: link,
                    target: "_blank",
                    size: "lg",
                    variant: "solid",
                    children: "Apply now"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CareerCard);


/***/ }),

/***/ "./src/components/Careers/CareersHero.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");



const CareersHero = (param)=>{
    let { title , description  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        my: -2,
        bgColor: "careersBackground",
        minH: "300px",
        py: "20",
        bgImage: "/images/backgrounds/homepage-bg-white.png",
        _dark: {
            bgImage: "/images/backgrounds/careers-background-dark.png"
        },
        bgSize: "cover !important",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
            justifyContent: "center",
            direction: "column",
            mx: "auto",
            maxW: "1120px",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6, {
                    textAlign: "center",
                    color: "careersHeadingColor",
                    fontWeight: 700,
                    fontSize: {
                        lg: "6xl",
                        md: "4xl",
                        base: "2xl",
                        "2xl": "7xl"
                    },
                    mb: {
                        base: 6,
                        md: 0
                    },
                    children: title
                }),
                description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                    color: "careersTextColor",
                    textAlign: "center",
                    mt: {
                        md: 3
                    },
                    fontSize: {
                        "2xl": "2xl",
                        md: "xl",
                        base: "md"
                    },
                    px: {
                        base: "3",
                        md: 0
                    },
                    children: "Do you wish to join our great team? we're looking for Intellectual Individuals who are committed to doing well by doing good. here is the list of our open positions."
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CareersHero);


/***/ }),

/***/ "./src/components/SEO/Static.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$p": function() { return /* binding */ CareersHeader; },
/* harmony export */   "BV": function() { return /* binding */ FaqSEO; },
/* harmony export */   "FV": function() { return /* binding */ TermsHeader; },
/* harmony export */   "Q_": function() { return /* binding */ GuidelinesHeader; },
/* harmony export */   "XJ": function() { return /* binding */ PrivacyPolicySEO; },
/* harmony export */   "d5": function() { return /* binding */ AboutHeader; }
/* harmony export */ });
/* unused harmony export CaPrivacyRightsHeader */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/next-seo/lib/next-seo.module.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/react/index.js");



const AboutHeader = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: "About",
        description: "World's largest crypto knowledge base whose mission is to bring the world's knowledge on-chain through the IQ token.",
        canonical: "https://iq.wiki/static/about",
        openGraph: {
            title: "About",
            description: "World's largest crypto knowledge base whose mission is to bring the world's knowledge on-chain through the IQ token."
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });
const FaqSEO = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: "FAQ",
        description: "Frequently Asked Questions about IQ.Wiki",
        titleTemplate: "%s | IQ.Wiki",
        canonical: "https://iq.wiki/static/faq",
        openGraph: {
            title: "FAQ",
            description: "Frequently Asked Questions about IQ.Wiki"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });
const PrivacyPolicySEO = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: "Our Policy",
        description: "IQ.Wiki Security center: Your Personal Information is our primary responsibility at IQ.Wiki",
        titleTemplate: "%s | IQ.Wiki",
        canonical: "https://iq.wiki/static/privacy",
        openGraph: {
            title: "Our Policy",
            description: "IQ.Wiki Security center: Your Personal Information is our primary responsibility at IQ.Wiki"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });
const CareersHeader = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: "Jobs",
        description: "Join us to spread the knowledge of blockchain | Search Job Openings across IQ.Wiki Network",
        titleTemplate: "%s | IQ.Wiki",
        canonical: "https://iq.wiki/careers",
        openGraph: {
            title: "Jobs",
            description: "Join us to spread the knowledge of blockchain | Search Job Openings across IQ.Wiki Network"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });
const CaPrivacyRightsHeader = ()=>/*#__PURE__*/ _jsx(NextSeo, {
        title: "CA Privacy Rights",
        description: "Get Started, Explore and make the most of IQ.Wiki",
        titleTemplate: "%s | IQ.Wiki",
        canonical: "https://iq.wiki/static/CaPrivacyRights",
        openGraph: {
            title: "CA Privacy Rights",
            description: "Get Started, Explore and make the most of IQ.Wiki"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });
const TermsHeader = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: "Terms of Service ",
        description: "Get Started, Explore and make the most of IQ.Wiki",
        titleTemplate: "%s | IQ.Wiki",
        canonical: "https://iq.wiki/static/terms",
        openGraph: {
            title: "Terms of Service",
            description: "Get Started, Explore and make the most of IQ.Wiki"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });
const GuidelinesHeader = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: "Our Guidelines",
        description: "IQ.Wiki guidelines for the community and network",
        titleTemplate: "%s | IQ.Wiki",
        canonical: "https://iq.wiki/static/guidelines",
        openGraph: {
            title: "Our Guidelines",
            description: "IQ.Wiki guidelines for the community and network"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWiki",
            site: "IQWiki"
        }
    });


/***/ }),

/***/ "./src/pages/careers/index.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ careers; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./src/components/Careers/CareersHero.tsx
var CareersHero = __webpack_require__("./src/components/Careers/CareersHero.tsx");
// EXTERNAL MODULE: ./src/components/SEO/Static.tsx
var Static = __webpack_require__("./src/components/SEO/Static.tsx");
;// CONCATENATED MODULE: ./src/data/CareersData.ts
const AllCareers = [
    {
        title: "Frontend developer",
        description: "Are you tired of working at a boring job that's sucking the life out of you? Do you want to work in a place where you can let your creativity run wild? If you answered \"yes\" to these questions, then we have the perfect job for you! \n\nWe are BrainDAO, and we're looking for a frontend developer to join our team. But we don't want just any ordinary developer, we want someone who's passionate, quirky, and isn't afraid to wear a tutu to work (we promise not to judge). \n\nAt BrainDAO, we work with the latest and greatest technologies, like chakraUI, nextJS, and redux. But don't worry if you're not familiar with these tools yet, we'll teach you everything you need to know (except how to ride a unicycle, you'll have to learn that on your own).\n\nWe want someone who's not afraid to speak their mind, and who's always up for a good laugh (or a bad pun). Bonus points if you can juggle while coding (just don't drop any balls on the CEO's head). \n\nSo if you're ready to join a team that's as fun as it is talented, then send us your application today! We can't wait to see what kind of weird and wonderful ideas you'll bring to the table.",
        location: "Remote",
        link: "https://forms.gle/EYYt4JudkVtnxZgE7"
    },
    {
        title: "Backend developer",
        description: "Are you a backend developer who loves to code in their pajamas? Do you dream in SQL queries and have a secret love affair with databases? Then we have the job for you! \n\nAt BrainDAO, we're looking for a backend developer to join our team (and to help us figure out why the coffee machine keeps spitting out code instead of caffeine). We use the latest and greatest technologies like nestJS, graphql, and PostgreSQL. But don't worry if you don't know these technologies yet, we'll teach you everything you need to know (except how to fix the coffee machine, that's a lost cause). \n\nWe're looking for someone who's passionate about backend development and isn't afraid to get their hands dirty (metaphorically speaking, we have a strict \"no mud wrestling\" policy in the office). You should be able to write clean, efficient code, and be a master at debugging (because let's face it, bugs are just as inevitable as bad hair days).\n\nSo, if you're ready to join a team of quirky, fun-loving developers who are as talented as they are hilarious, then send us your application today! We can't wait to see what kind of backend magic you'll bring to the table.",
        location: "Remote",
        link: "https://forms.gle/EYYt4JudkVtnxZgE7"
    },
    {
        title: "AI developers",
        description: "Are you an AI Developer with an insatiable appetite for a challenge? Then this job opportunity is for you! We are looking for an ambitious and creative AI Developer to join our team and help solve some of the most complex problems in the tech industry. \n\nYou will have the opportunity to work with the most cutting edge technologies and develop innovative solutions that have the potential to make a real impact on the world.If you’re looking to take your AI development career to the next level, then this is the job for you! So, c’mon – let’s get coding and make some magic!",
        link: "https://forms.gle/EYYt4JudkVtnxZgE7",
        location: "Remote"
    }
];

// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/image/dist/index.esm.js
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/image/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__("./node_modules/react-i18next/dist/es/useTranslation.js");
;// CONCATENATED MODULE: ./src/components/Careers/NoOpeningsCard.tsx




const NoOpenings = ()=>{
    const { t  } = (0,useTranslation/* useTranslation */.$)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
        mt: {
            base: 5
        },
        mb: {
            base: 2
        },
        direction: "column",
        align: "center",
        justify: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Image */.Ee, {
                flex: 1,
                marginInlineStart: "0 !important",
                src: "/images/svg-images/no-careers-state.svg",
                w: {
                    base: "60%",
                    sm: "50%",
                    md: "55%",
                    lg: "45%"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                textAlign: "center",
                mt: 8,
                mb: 4,
                as: "h1",
                fontSize: {
                    md: "2xl",
                    lg: "4xl",
                    base: "xl"
                },
                letterSpacing: "wide",
                children: t("noOpeningsHeading")
            })
        ]
    });
};
/* harmony default export */ var NoOpeningsCard = (NoOpenings);

;// CONCATENATED MODULE: ./src/components/Careers/NoCareersHero.tsx






const NoCareersPage = ()=>{
    const { t  } = (0,useTranslation/* useTranslation */.$)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Static/* CareersHeader */.$p, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                mb: {
                    lg: 24,
                    md: 20,
                    base: 10
                },
                direction: "column",
                w: "90%",
                mx: "auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                        mt: 8,
                        mb: 4,
                        as: "h1",
                        fontSize: {
                            lg: "4xl",
                            md: "4xl",
                            base: "2xl"
                        },
                        letterSpacing: "wide",
                        children: t("careerHeading")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                        direction: "column",
                        align: "center",
                        justify: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoOpeningsCard, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var NoCareersHero = (NoCareersPage);

// EXTERNAL MODULE: ./src/components/Careers/CareersCard.tsx
var CareersCard = __webpack_require__("./src/components/Careers/CareersCard.tsx");
;// CONCATENATED MODULE: ./src/pages/careers/index.tsx








const OurCareers = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CareersHero/* default */.Z, {
                title: "IQ.Wiki Careers",
                description: "Do you wish to join our great team? we're looking for Intellectual Individuals who are committed to doing well by doing good. here is the list of our open positions."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                maxW: {
                    base: "100%",
                    md: "95%",
                    "2xl": "1280px"
                },
                py: {
                    base: 8,
                    lg: 16
                },
                mx: "auto",
                px: {
                    base: "5",
                    md: 0
                },
                gap: {
                    base: 10,
                    md: "15"
                },
                children: AllCareers.map((career, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CareersCard/* default */.Z, {
                        title: career.title,
                        location: career.location,
                        description: career.description,
                        link: career.link
                    }, i))
            })
        ]
    });
};
const Careers = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Static/* CareersHeader */.$p, {}),
            AllCareers.length !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OurCareers, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NoCareersHero, {})
        ]
    });
};
/* harmony default export */ var careers = (Careers);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__("./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Fcareers%2Findex.tsx&page=%2Fcareers!"); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);